"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBaloonHolidays = function SvgBaloonHolidays(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.143 17.187c.82 1.33 3.418 3.963 7.242 3.842M4.751 5.278c-1.244 3.038.112 5.956 1.079 7.061.966 1.105 2.89 2.589 5.05 3.146.682.175 1.245.409 1.565.624.327.22.13.28.33-.071a4.102 4.102 0 0 1 1.034-1.182c1.742-1.395 2.887-3.537 3.315-4.942.427-1.404.466-4.621-1.915-6.882-1.454-1.38-3.784-1.995-5.756-1.672-1.967.323-3.97 2.129-4.702 3.918z",
    stroke: "#919499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.796 17.274c-.236.091-.616.185-.66-.017-.03-.145.05-.314.144-.506.085-.177.18-.374.205-.59l.139-.03c.11.187.278.328.43.454.162.137.306.258.337.403.044.202-.342.272-.595.286z",
    stroke: "#919499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.76c1.173.31 3.534 1.731 3.597 4.93",
    stroke: "#919499",
    strokeLinecap: "round"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBaloonHolidays);
var _default = exports["default"] = Memo;